import { Component, OnInit, HostListener, Inject } from '@angular/core';
import { Router, NavigationEnd} from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { MainLayoutService } from './layout/services/main-layout.service';
import { WebApiClient } from './services/web-api-client.service';
import { EasyNotificationService } from './services/easy-notification.service';
import { WebApiService } from './services/web-api.service';
import { UserCache } from './services/user-cache';
//import { BaseConfig } from './shared/services/base-config.service';


@Component({
  selector: 'app-root',
  template: `<router-outlet></router-outlet>`,
})
export class AppComponent implements OnInit {
  // api服務
  api: WebApiService;
  // 通知服務
  notification: EasyNotificationService;

  constructor(private router: Router,
    private mainLayoutService: MainLayoutService,
    private titleService: Title,
    private webApiClient: WebApiClient,
    @Inject(DOCUMENT) private document: Document
  ) {
    // Browser Title目前是固定不變
    this.titleService.setTitle('Cloud Clinics');
    this.api = this.webApiClient.createHisService('system/user');

    this.router.events.subscribe(e => {
      try {
        history.pushState(null, '', location.href);
      } catch { }
    })
    window.onpopstate = function () {
      history.go(1);
    };
    //卡一下過度縮放的上下限
    window.onresize = ()=>{
      var scale = window.devicePixelRatio>1.5? 1.5:window.devicePixelRatio<0.75?0.75:window.devicePixelRatio;
      AppComponent.zoom =scale/window.devicePixelRatio;
      document.body.style.zoom = AppComponent.zoom.toString();
      // 更新 CSS 變數來修正 overlay 定位
      document.documentElement.style.setProperty('--zoom-correction', (1 / AppComponent.zoom).toString());
    }
    var scale = window.devicePixelRatio>1.5? 1.5:window.devicePixelRatio<0.75?0.75:window.devicePixelRatio;
    AppComponent.zoom =scale/window.devicePixelRatio;
    document.body.style.zoom = AppComponent.zoom.toString();
    // 更新 CSS 變數來修正 overlay 定位
    document.documentElement.style.setProperty('--zoom-correction', (1 / AppComponent.zoom).toString());
  }
  static zoom:number = 1;
  // dynamic load style
  loadStyle(styleName: string) {
    const head = this.document.getElementsByTagName('head')[0];
    const style = this.document.createElement('link');
    style.id = styleName;
    style.rel = 'stylesheet';
    style.href = `${styleName}`;
    head.appendChild(style);
  }

  ngOnInit() {
    this.routerEventHandler();
  }


  @HostListener('window:beforeunload', ['$event'])
  winBeforeUnload($event) {
    // 為了安全，window.beforeunload時會把資料存到(覆蓋)localStorage
    // 詳見UserCache說明
    //UserCache.setLoginUserFromMemory();
  }

  private routerEventHandler() {
    this.router.events
      //.filter((event) => event instanceof NavigationEnd)
      .subscribe((routeInfo) => {
        if(routeInfo instanceof NavigationEnd){
                this.mainLayoutService.showMenu(); // 預設show menu，每次都設不然某些畫面關閉後，這邊又要打開
                const clinicName = UserCache.getLoginUser()?.ClinicName;
                this.titleService.setTitle(clinicName ? `CHIS - ${clinicName}` : 'CHIS');
        }
      });
  }


}

